import "./styles.css"
import { useEffect, useState } from "react";
import { ReactComponent as PlusIcon } from "../../../assets/svg/icons/plus.svg";
import { useEditOnboarding } from "../../../hooks/useEditOnboarding";
import TableEvaluationRow from "./TableVisualizationRow/Index";
import { useTaskCreation } from "../../../hooks/useTaskCreation";
import InfoEvaluation from "../../Tasks/ViewTasks/InfoEvaluation";
import axios from "../../../services/axios"
import { IOptionsEvaluation } from "../../ViewTables/Index";
import { useFilter } from "../../../hooks/useFilter";
import { Loading } from "../../Loading/Index";
import { ReactComponent as ArrowIcon } from "../../../assets/svg/icons/rightChevron.svg"
import { useTableMonitor } from "../../../hooks/useTableMonitor";

interface TableProductsProps {
  listTable: IMicroAreaEvaluation[];
  filter: IOptionsEvaluation | undefined;
  isLoading: boolean;
}

export default function TableEvaluation({ listTable, filter, isLoading }: TableProductsProps) {
  const {
    setOptionForm,
  } = useEditOnboarding();
  const { setSystemManager } = useFilter();
  const { setModalCreateEvaluator, setModalStartEvaluator, modalStartEvaluator, } = useTaskCreation();
  const [haveEvaluator, setHaveEvaluator] = useState(false);
  const [startedEvaluation, setStartedEvaluation] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const { selectedOrder, setSelectedOrder, sortAsc, setSortAsc } = useTableMonitor();

  useEffect(() => {
    setSelectedOrder("createdAt")
  }, []);

  useEffect(() => {
    axios.get("users/user/evaluator")
      .then(({ data }) => {
        setHaveEvaluator(data.filter((el: any) => el.status == "ACTIVE").length > 0)
      })
    axios.get(`tasks/pasture-evaluation`)
      .then(({ data }) => {
        setStartedEvaluation(data.total_elements > 0)
      })
  }, [, modalStartEvaluator]);

  const statusMap = new Map<string, string>()
  statusMap.set("COMPLETED", "Avaliado")
  statusMap.set("PENDING", "Pendente")
  statusMap.set("CANCELED", "Cancelada")
  statusMap.set("PENDING", "Pendente")
  statusMap.set("ERROR", "Erro")

  return (
    <>
      {
        isLoading
          ?
          <div className="emptyTable_container">
            <Loading visible={isLoading} />
          </div>
          :

          <>
            {!haveEvaluator ?
              <div className="emptyTable_container">
                <span>Para iniciar a avaliação, é necessário alocar um responsável como avaliador.</span>
                <div
                  className="addProduct_button"
                  onClick={() => {
                    setOptionForm("create-evaluator")
                    setModalCreateEvaluator(true)
                    setSystemManager("MANAGER_EVALUATORS")
                  }}
                >
                  <PlusIcon />
                  <span>Adicionar avaliador</span>
                </div>
              </div>
              :
              (!startedEvaluation ?
                (
                  <div className="emptyTable_container">
                    <span>Inicie a avaliação para começar a visualizar os pastos avaliados.</span>
                    <div
                      className="addProduct_button"
                      onClick={() => {
                        setModalStartEvaluator(true)
                      }}
                    >
                      <span>Iniciar avaliação</span>
                    </div>
                  </div>
                )
                :
                (
                  listTable && listTable.length > 0 ?
                    <>
                      <section className="tableColumnEvaluation">
                        {[
                          { key: "evaluator", label: "Usuário" },
                          { key: "microAreaInitials", label: "Pasto" },
                          { key: "status", label: "Status" },
                          { key: "createdAt", label: "Data Criação", },
                          { key: "updatedAt", label: "Data Execução" },
                        ].map(({ label, key }) => (
                          <div
                            key={key}
                            onClick={() => {
                              setSelectedOrder(key);
                              if (selectedOrder !== key) {
                                setSortAsc(false);
                                return;
                              }
                              setSortAsc(!sortAsc);
                            }}
                            className="infoColumn"
                          >
                            {label}
                            <ArrowIcon
                              className={`iconSort${sortAsc ? "--asc" : ""}`}
                              style={{
                                display: selectedOrder === key ? "block" : "none",
                              }}
                            />
                          </div>
                        ))}
                        <div />
                      </section>

                      <section
                        className="tableViewRows"
                        style={{
                          position: "relative",
                        }}
                      >
                        <Loading visible={isLoading} />

                        {listTable.map(evaluation =>
                          <TableEvaluationRow evaluation={evaluation} setSelectedId={setSelectedId} />
                        )}
                      </section>
                    </>
                    :
                    <div className="emptyTable_container">
                      {filter ? <span>Nenhum resultado encontrado para o estado {statusMap.get(filter)}.</span> : <span> Nenhum resultado encontrado.</span>}
                    </div>
                ))
            }
            <InfoEvaluation
              selected={selectedId}
              setSelectedId={setSelectedId}
            />
          </>
      }
    </>
  )
}